export default __webpack_public_path__ + "static/media/5_home-image.06312d6f.jpg";